import { z } from "zod";
//#region src/api/orpc/util/offsetPagination.ts
/**
* Standard offset-based pagination input. Defaults: page/pageSize
* `1..100`. Routes may re-declare with stricter bounds via `.extend()`.
* `z.coerce` is preserved on overrides because query params arrive as
* strings.
*
* The server's `api/orpc/utils/offsetPagination.ts` re-exports this and
* adds runtime helpers (`toPrismaOffsetArgs`, `OffsetPaginator`, etc.)
* that depend on Prisma; the contract package only ships the
* wire-format schema.
*/
const offsetPaginationInputSchema = z.object({
	page: z.coerce.number().int().min(1).max(100).default(1),
	pageSize: z.coerce.number().int().min(1).max(100).default(20)
});
/**
* Schema factory mirroring `createCursorListResponseSchema`. Builds the
* standard offset/page-based list response shape around an item schema.
*
* `totalCount` is optional so routes that don't bother counting (e.g. paged
* lists where the count requires an extra query) can omit it without
* breaking the contract.
*/
const createOffsetListResponseSchema = (itemSchema) => z.object({
	data: z.array(itemSchema),
	page: z.number().int().min(1),
	pageSize: z.number().int().min(1),
	totalPage: z.number().int().nonnegative(),
	totalCount: z.number().int().nonnegative().optional()
});
//#endregion
export { createOffsetListResponseSchema, offsetPaginationInputSchema };
